import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import UserPhotoField from '../../../Shared/Components/UserPhotoField'

const UsersCreate = ({ roles }) => {
    const { flash } = usePage().props

    const form = useForm({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: roles.length ? roles[0].name : 'Admin',
        status: true,
        email_verified_at: '',
        photo: null,
        remove_photo: false,
    })

    const submit = (e) => {
        e.preventDefault()
        form.post(route('admin.users.store'), { forceFormData: true })
    }

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath="/admin/users/create" />
            </div>

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">Nuevo usuario</h1>
                <Link href={route('admin.users.list')} className="btn btn-sm btn-light">
                    ← Volver al listado
                </Link>
            </div>

            {flash.success && <div className="alert alert-success mb-5">{flash.success}</div>}

            <Card>
                <Card.Body>
                    <p className="text-muted mb-4">Solo se pueden asignar roles <strong>Admin</strong> u <strong>Owner</strong>.</p>
                    <Form onSubmit={submit}>
                        <Row className="g-3 mb-4">
                            <Col md={12}>
                                <UserPhotoField
                                    currentUrl={null}
                                    file={form.data.photo}
                                    removePhoto={form.data.remove_photo}
                                    onFileChange={(file) => {
                                        form.setData((d) => ({
                                            ...d,
                                            photo: file,
                                            remove_photo: file ? false : d.remove_photo,
                                        }))
                                    }}
                                    onRemoveToggle={(v) => {
                                        form.setData((d) => ({
                                            ...d,
                                            remove_photo: v,
                                            photo: v ? null : d.photo,
                                        }))
                                    }}
                                    error={form.errors.photo}
                                    disabled={form.processing}
                                />
                            </Col>
                        </Row>
                        <Row className="g-3 mb-3">
                            <Col md={6}>
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control value={form.data.name} onChange={(e) => form.setData('name', e.target.value)} required />
                                {form.errors.name && <div className="text-danger small">{form.errors.name}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label>Correo</Form.Label>
                                <Form.Control type="email" value={form.data.email} onChange={(e) => form.setData('email', e.target.value)} required />
                                {form.errors.email && <div className="text-danger small">{form.errors.email}</div>}
                            </Col>
                        </Row>
                        <Row className="g-3 mb-3">
                            <Col md={6}>
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control type="password" value={form.data.password} onChange={(e) => form.setData('password', e.target.value)} required />
                                {form.errors.password && <div className="text-danger small">{form.errors.password}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label>Confirmar contraseña</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={form.data.password_confirmation}
                                    onChange={(e) => form.setData('password_confirmation', e.target.value)}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <Form.Label>Rol</Form.Label>
                                <Form.Select value={form.data.role} onChange={(e) => form.setData('role', e.target.value)}>
                                    {roles.map((r) => (
                                        <option key={r.id} value={r.name}>
                                            {r.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                {form.errors.role && <div className="text-danger small">{form.errors.role}</div>}
                            </Col>
                            <Col md={4}>
                                <Form.Label>Activo</Form.Label>
                                <Form.Select
                                    value={form.data.status ? '1' : '0'}
                                    onChange={(e) => form.setData('status', e.target.value === '1')}
                                >
                                    <option value="1">Sí</option>
                                    <option value="0">No</option>
                                </Form.Select>
                                {form.errors.status && <div className="text-danger small">{form.errors.status}</div>}
                            </Col>
                            <Col md={4}>
                                <Form.Label>Email verificado (opcional)</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    value={form.data.email_verified_at}
                                    onChange={(e) => form.setData('email_verified_at', e.target.value)}
                                />
                                {form.errors.email_verified_at && <div className="text-danger small">{form.errors.email_verified_at}</div>}
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={form.processing}>
                            Crear usuario
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}

UsersCreate.layout = (page) => <Layout title="Nuevo usuario">{page}</Layout>

export default UsersCreate
